export enum DevisStatut {
  CREE      = 'CREE',       // Devis en cours de rédaction (CDC)
  EN_ATTENTE = 'EN_ATTENTE', // Soumis à validation SNCF
  ACCEPTE   = 'ACCEPTE',    // Validé par SNCF
  REFUSE    = 'REFUSE',     // Refusé par SNCF
  ARCHIVE   = 'ARCHIVE'     // Clôturé (facturé ou refusé)
}

export interface IActiviteDevisDTO {
  activitefebId?: string | null;
  label: string;
  pourcentage: number;
}

export interface IDevisResponse {
  devisId: string;
  devisReference?: string | null;
  devisStatut: DevisStatut;
  demandId?: string | null;

  // Chiffrage / contrat
  devisNumeroContrat?:    string  | null;
  devisNomContrat?:       string  | null;
  devisBeneficiaire?:     string  | null;
  devisMajore?:           boolean | null;
  febPrixUoGrille?:       number  | null;
  febPrixUoGrilleMajore?: number  | null;
  devisPrixUoGrille?:     number  | null;
  devisPrixUoPropose?:    number  | null;
  devisDateDemarrageGo?:  string  | null;
  devisdDateFinPrevisionnelle?: string  | null;
  devisDuree?:            number  | null;
  devisProvisionFrais?:   number  | null;
  devisMontantTotal?:     number  | null;
  devisCommentaire?:      string  | null;
  devisDateFinTravaux?:   string  | null;
  devisNumeroBonCommande?: string | null; // alias frontend
  devisNumeroBdc?:              string  | null; // nom retourné par le backend
  devisMotifRefus?:             string  | null;
  devisMotifRetourArriere?:     string  | null;
  dateEntretien?:             string  | null;

  // Audit
  devisCreatedAt: string;
  devisUpdatedAt: string;

  // Données FEB (lecture seule)
  febId:                        string;
  febLabel?:                    string | null;
  febProjectNom?:               string | null;
  febDateDemande?:              string | null;
  febEntiteSncfNom?:            string | null;
  febDivisionDemandeurNom?:     string | null;
    febUoActivitePressentiLabel?: string | null;
  febNomenclature?:             string | null;
  febLocalisationLabel?:        string | null;
  febPcSncf?:                   boolean | null;
  febPresenceSiteSncf?:         string | null;
  febContexteObjectifProjet?:   string | null;
  febActivites?:                IActiviteDevisDTO[] | null;
}

export interface IDevisRequest {
  devisMajore?:            boolean | null;
  devisPrixUoPropose?:     number  | null;
  devisCommentaire?:       string  | null;
  devisNumeroContrat?:     string  | null;
  devisNomContrat?:        string  | null;
  devisBeneficiaire?:      string  | null;
  devisDateDemarrageGo?:   string  | null;
  devisDuree?:             number  | null;
  devisProvisionFrais?:    number  | null;
  devisDateFinTravaux?:    string  | null;
  devisNumeroBonCommande?: string  | null;
  devisMotifRefus?:        string  | null;
  dateEntretien?:             string  | null;
}


export interface IDevisCreateRequest {
  febId: string;

  devisNumeroContrat?: string;
  devisNomContrat?: string;

  devisBeneficiaire?: string;
  devisMajore?: boolean;

  devisPrixUoPropose?: number;
  devisProvisionFrais?: number;
  devisDuree?: number;

  devisDateDemarrageGo?: string;
  devisDateEntretien?: string;

  devisCommentaire?: string;
}